import { Form } from 'antd';

import { TextInput } from '@/shared/ui/TextInput/TextInput';

import {
  buildConnectorFieldRules,
  type ConnectorField,
  getConnectorFieldPlaceholder,
  type UpdateConnectorRequest,
} from '@/entities/connector';

import { ASSET_URI_FIELDS } from '@/features/connectors/model/useAssetURIFieldsReset';
import { AssetUriTooltip } from '@/features/connectors/ui/AssetUriTooltip';

import styles from './EditConnectorDataInfoSection.module.css';

type EditConnectorDataInfoSectionProps = {
  disabled?: boolean;
  dataInfo?: UpdateConnectorRequest['dataInfo'];
};

const FIELD_PLACEHOLDER = 'Input';
const DATA_INFO_TITLE = '기본 정보';
const DATA_INFO_LABELS: Record<string, string> = {
  enterprise: 'Enterprise',
  site: 'Site',
  area: 'Area',
  process: 'Process',
  unit: 'Unit',
  component: 'Component',
  dataName: 'Name',
};

const buildDataInfoRules = (field: ConnectorField) => buildConnectorFieldRules({ ...field });
const getInitialValue = (dataInfo: UpdateConnectorRequest['dataInfo'] | undefined, fieldLabel: string) =>
  dataInfo?.[fieldLabel as keyof UpdateConnectorRequest['dataInfo']];

export const EditConnectorDataInfoSection = ({ disabled = false, dataInfo }: EditConnectorDataInfoSectionProps) => {
  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            {DATA_INFO_TITLE}
            <AssetUriTooltip iconClassName={styles.tooltipIcon} />
          </h3>

          <div className={styles.fields}>
            {ASSET_URI_FIELDS.dataInfo.map((field) => (
              <Form.Item
                key={field.label}
                name={['dataInfo', field.label]}
                initialValue={getInitialValue(dataInfo, field.label)}
                label={DATA_INFO_LABELS[field.label] ?? field.label}
                required={field.required}
                rules={buildDataInfoRules(field)}
                className={styles.field}>
                <TextInput
                  className={styles.textInput}
                  disabled={disabled}
                  placeholder={getConnectorFieldPlaceholder(field)}
                />
              </Form.Item>
            ))}
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.section}>
          <div className={styles.fields}>
            {ASSET_URI_FIELDS.dataName.map((field) => (
              <Form.Item
                key={field.label}
                name={['dataInfo', field.label]}
                initialValue={getInitialValue(dataInfo, field.label)}
                label={DATA_INFO_LABELS[field.label] ?? field.label}
                required={field.required}
                rules={buildDataInfoRules(field)}
                className={styles.field}>
                <TextInput className={styles.textInput} disabled={disabled} placeholder={FIELD_PLACEHOLDER} />
              </Form.Item>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
